import { ENABLE_USER_BILLING } from '../config/featureFlags'
import {
  BILLING_NUDGE_TZ,
  calendarDaysFromTodayToEndInclusive,
  dateStringForInstantInTimeZone,
  dateStringInTimeZone,
  isOrgPaysCurrentlyEffective,
} from './billingPaywallNudge'

/**
 * @param {Record<string, unknown>|null|undefined} billingMe
 * @returns {{ planLabel: string, detail: string, showPaymentLink: boolean, badgeLabel?: string }|null}
 */
export function buildSidebarSubscriptionInfo(billingMe) {
  if (!billingMe || typeof billingMe !== 'object') return null

  const orgContractPrimary = billingMe.orgContractPrimary === true
    || String(billingMe.effectiveBillingSource || '').toUpperCase() === 'ORG_CONTRACT'
    || isOrgPaysCurrentlyEffective(billingMe.orgContract)
  if (orgContractPrimary) {
    const orgContract = billingMe.orgContract
    const quote = billingMe.quote && typeof billingMe.quote === 'object' ? billingMe.quote : null
    const planLabel = orgContract?.planName
      || formatSidebarPlanCodeLabel(orgContract?.appliedPlanCode)
      || quote?.planName
      || '조직 계약'
    const endsAtYmd = dateStringForInstantInTimeZone(orgContract?.endsAt, BILLING_NUDGE_TZ)
    return {
      badgeLabel: '조직 계약',
      planLabel,
      detail: endsAtYmd ? `만료 ${endsAtYmd.replace(/-/g, '.')}` : '조직 결제 적용',
      showPaymentLink: false,
    }
  }

  const subscription = billingMe.subscription && typeof billingMe.subscription === 'object'
    ? billingMe.subscription
    : null
  if (!subscription) return null

  const planLabel = subscription.planName
    ? String(subscription.planName)
    : (subscription.planCode ? String(subscription.planCode) : '구독')
  const status = String(subscription.status || '').toUpperCase()

  if (status === 'TRIAL') {
    const trialEnds = subscription.activeTrialGrant?.endsAt || subscription.endsAt
    const endsAtYmd = dateStringForInstantInTimeZone(trialEnds, BILLING_NUDGE_TZ)
    return {
      planLabel: `${planLabel} · 체험`,
      detail: endsAtYmd ? `만료 ${endsAtYmd.replace(/-/g, '.')}` : '체험 이용중',
      showPaymentLink: ENABLE_USER_BILLING,
    }
  }

  const endsAtYmd = dateStringForInstantInTimeZone(subscription.endsAt, BILLING_NUDGE_TZ)
  const todayYmd = dateStringInTimeZone(new Date(), BILLING_NUDGE_TZ)
  const daysLeft = endsAtYmd && todayYmd
    ? calendarDaysFromTodayToEndInclusive(todayYmd, endsAtYmd)
    : null

  let detail = '-'
  if (status === 'EXPIRED') detail = '만료됨'
  else if (status === 'SUSPENDED') detail = '정지됨'
  else if (daysLeft !== null && daysLeft >= 0) detail = `잔여일 ${daysLeft}일`
  else if (endsAtYmd) detail = `만료 ${endsAtYmd.replace(/-/g, '.')}`

  return {
    planLabel,
    detail,
    showPaymentLink: ENABLE_USER_BILLING,
  }
}

function formatSidebarPlanCodeLabel(value) {
  const normalized = String(value || '').toUpperCase()
  if (normalized === 'BASIC') return '베이직'
  if (normalized === 'STANDARD') return '스탠다드'
  if (normalized === 'PREMIUM') return '프리미엄'
  if (normalized === 'ENTERPRISE') return '엔터프라이즈'
  return ''
}
